import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/browser'

const debug = import.meta.env.VITE_MONITOR_DEBUG === 'true'
const verbose = import.meta.env.VITE_MONITOR_VERBOSE === 'true' || import.meta.env.DEV

const config = {
  debug: import.meta.env.VITE_SENTRY_DEBUG === 'true',
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.VITE_SENTRY_ENABLED !== 'false' && (import.meta.env.VITE_SENTRY_ENABLED === 'true' || ['production', 'demo', 'staging'].includes(import.meta.env.BUP_MODE)),
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.BUP_MODE || 'unknown',
  tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0.05
}

if (debug) console.info('[monitor]', 'config', config)

if (verbose) console.info('[monitor]', 'initializing...')
if (config.dsn && config.dsn.match(/\.sentry\.io/)) {
  try {
    Sentry.init({
      ...config,
      integrations: [new BrowserTracing()]
    })
    if (verbose) console.info('[monitor]', 'initialized.')
  } catch (error) {
    if (verbose) console.warn('[monitor]', 'sentry intialization failed', error.message)
  }
} else {
  if (verbose) console.warn('[monitor]', 'sentry intialization failed', 'dsn is missing or invalid')
}

export function captureException (...args) {
  return Sentry.captureException(...args)
}

export default {
  captureException
}
